import { render } from "./PivotTable.vue?vue&type=template&id=ddec79f8"
import script from "./PivotTable.vue?vue&type=script&lang=js"
export * from "./PivotTable.vue?vue&type=script&lang=js"

import "./PivotTable.vue?vue&type=style&index=0&id=ddec79f8&lang=scss"

import exportComponent from "/app/tmp/aft/V3/v2026.4.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__